import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import util from '@/Utils/util';

export const fetchAbTestRecordsFromProd = async () => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation fetchAbTestRecordsFromProd {
        fetchAbTestRecordsFromProd {
          abTests {
            created
            updated
          }
          abTestGroups {
            created
            updated
          }
          abTestExclusives {
            created
            updated
          }
          warningMessage
        }
      }
    `),
  });

  if (response.errors?.length) {
    throw new Error(util.getGraphqlError({ graphQLErrors: response.errors }, false), { cause: response });
  }

  if (!response.data?.fetchAbTestRecordsFromProd) {
    throw new Error('Unexpected empty response');
  }

  return response.data.fetchAbTestRecordsFromProd;
};
